import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as UserStore from './user.reducer';

export const selectState = createFeatureSelector<UserStore.State>(
  UserStore.userFeatureKey,
);

/**
 *  getCurentProgramType selector return the current selected ProgramType
 */
export const getLastUsedProgramType = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.roles ? state.roles.lastUsedRole?.program?.programType : undefined;
  },
);

/**
 *  getCurentProgramId selector return the current selected ProgramId
 */
export const getCurentProgramUid = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.roles ? state.roles.lastUsedRole?.program?.uid : undefined;
  },
);


/**
 *  getBusinessProgramTypes selector return the programTypesList
 */
export const getBusinessProgramTypes = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.roles ? state.roles.roles.map(role=> role.program.programType) : undefined;
  },
);

/**
 *  getBusinessProgramTypes selector return the programTypesList
 */
export const getUserRoles = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.roles ? state.roles : undefined;
  },
);

/**
 *  getCurrentUserRole selector return the current selected UserRole
 */
export const getLastUsedRoleType = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.roles ? state.roles.lastUsedRole?.roleType : undefined;
  },
);

/**
 *  getCurrentUserRole selector return the current selected UserRole
 */
export const getLastUsedRoleBusinessUid = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.roles ? state.roles.lastUsedRole?.program?.companyUid  : undefined;
  },
);

/**
 *  getCurrentUserRole selector return the current selected UserRole
 */
export const getLastUsedBusinessProgramUid = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.roles && state.roles.lastUsedRole
    ? { businessUid: state.roles.lastUsedRole?.program?.companyUid,
       programUid: state.roles.lastUsedRole?.program?.uid }
    : undefined;
  },
);

/**
 *  getCurrentRole selector return the current selected UserRole
 */
export const getLastUsedRole = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.roles ? state.roles.lastUsedRole : undefined;
  },
 );

/**
 *  Get user current role and user object
 */
export const getUserInformation = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state ?  { user: state.user, role: state.roles } : undefined;
  },
 );

/**
 *  check whether user profile already created or not
 */
export const isUserProfileExist  = createSelector(
  selectState,
  (state: UserStore.State) =>  state && state.user ? state.user.isDefaultAddressExist : false,
 );


/**
 *  getUserRoles selector return the userRole
 */
export const getNativeRoles = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.nativeRoles ? state.nativeRoles : [];
  },
);

/**
 *  getBusiness selector return the business
 */
export const getBusiness = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.roles ? state.roles.business : undefined;
  },
);

/**
 *  getBusiness selector return the business
 */
export const showProgramSwitchMenu = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.showProgramSwitchMenu !== null ? state.showProgramSwitchMenu : false;
  },
);


/**
 *  get Error
 */
export const getError = createSelector(
  selectState,
  (state: UserStore.State) => {
    return state && state.error ? state.error : undefined;
  },
);

/**
 *  get the flag to see if user accepted the Client API
 */
 export const getAcceptTermsAndConditions  = createSelector(
  selectState,
  (state: UserStore.State) =>  state && state.user ? state.user.isPrivacyTermsConditionsAccepted : false,
 );

/**
 *  get the flag to see if user accepted the Client API
 */
export const getAcceptTermsAndConditionsAPI  = createSelector(
  selectState,
  (state: UserStore.State) =>  state && state.user ? state.user.isPrivacyTermsConditionsAPIAccepted : false,
 );
